import styled from "styled-components";
import colors from "../../theme/color/ColorTheme";
import fontSize from "../../theme/fonts/FontTheme";

const Button = styled.button`
  position: relative;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  letter-spacing: 0.1rem;
  text-transform: capitalize;
  color: ${({ $color }) => $color || colors.black};
  font-size: ${fontSize.xxs};

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -2px;
    width: 100%;
    height: 1px;
    background-color: ${({ $color }) => $color || colors.black};
    transform: translateX(-50%) scaleX(1);
    transform-origin: center;
    transition: transform 0.3s ease;
  }

  &:hover::after {
    transform: translateX(-50%) scaleX(0);
  }
`;

function UnderlineButton({ placeholder, onClick, color }) {
  return <Button $color={color} onClick={onClick}>{placeholder}</Button>;
}

export default UnderlineButton;
